import {
  Dispatch,
  ReactNode,
  SetStateAction,
  useEffect,
  useMemo,
  useState,
} from 'react';
import { useMatch } from 'react-router-dom';

import createSafeContext from '#/utils/createSafeContext';

import { FUTURES_SYMBOL_ROUTE } from '#/routes';

interface StoreState {
  readonly symbol: string | null;
}

const INITIAL_STATE: StoreState = {
  symbol: null,
};

interface View {
  readonly lastVisitedSymbol: string | null;
}

export const [useLastVisitedFutureSymbolView, ViewProvider] =
  createSafeContext<View>('LastVisitedFutureSymbolView');

interface Props {
  readonly children: ReactNode;
}

export function LastVisitedFutureSymbolProvider(props: Props) {
  const [store, setStore] = useState(INITIAL_STATE);

  useLastFutureSymbolUpdater(setStore);

  const view = useMemo(() => createView(store), [store]);

  return <ViewProvider value={view}>{props.children}</ViewProvider>;
}

function createView(store: StoreState): View {
  return { lastVisitedSymbol: store.symbol };
}

function useLastFutureSymbolUpdater(
  setStore: Dispatch<SetStateAction<StoreState>>,
) {
  const routeMatch = useMatch(FUTURES_SYMBOL_ROUTE);
  const symbol = routeMatch?.params.symbol;

  useEffect(() => {
    if (symbol == null) return;
    setStore((prev) => ({ ...prev, symbol }));
  }, [setStore, symbol]);
}
